module.exports = __webpack_public_path__ + "static/media/user-icon.63a00472.svg";